<template>
  <b-modal
    :id="'postcode-lookup-modal-' + _uid"
    centered
    size="lg"
    ok-title="Use Address"
    ok-variant="success"
    :title="'Select address'"
    :busy="busy"
    :no-close-on-backdrop="busy"
    :no-close-on-esc="busy"
    :hide-header-close="busy"
    @ok="save"
  >
    <b-form-select
      v-if="!busy"
      v-model="address"
      :options="options"
    ></b-form-select>

    <div class="postcode-lookup-result">
      <b-button variant="link"> </b-button>
    </div>

    <div class="loading-state text-center" v-if="busy">
      <p>Looking up postcode...</p>

      <b-spinner style="width: 3rem; height: 3rem"></b-spinner>
    </div>
  </b-modal>
</template>
<script>
import { map } from "lodash-es";

import Vue from "vue";

import { ListGroupPlugin } from "bootstrap-vue";
Vue.use(ListGroupPlugin);

export default {
  data() {
    return {
      results: [],
      address: false,
      busy: false,
      active_index: false,
    };
  },
  components: {},
  props: {
    postcode: {
      type: String,
      default: "",
    },
  },
  computed: {
    options() {
      return map(this.results, (v) => {
        return { value: v, text: this.$options.filters.inlineAddress(v) };
      });
    },
  },
  methods: {
    save() {
      this.$emit("input", this.address);
    },
    lookup() {
      if (this.postcode.length < 1) {
        return this.showError("Please enter a postcode");
      }
      this.busy = true;
      this.$bvModal.show("postcode-lookup-modal-" + this._uid);

      this.$store
        .dispatch("user/lookup_postcode", this.postcode)
        .then((response) => {
          this.busy = false;

          this.results = response.data;

          if (this.results.length < 1) {
            this.showError(
              "Postcode not found",
              "We found no results for that postcode. Please check and try again."
            );
            this.$bvModal.hide("postcode-lookup-modal-" + this._uid);
            return;
          }

          this.address = this.results[0];
        })
        .catch((err) => {
          this.showError(
            "Error resolving postcode",
            "Sorry, we couldn't look up your postcode at this time. Please try again later, or contact us for assistance.",
            err
          );
          this.busy = false;
          this.$bvModal.hide("postcode-lookup-modal-" + this._uid);
        });
    },
  },
};
</script>